import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

const isQaMonitorRoute = routeState => {
  const routeName = String(routeState?.name || '');
  const routePath = String(routeState?.path || '');

  return (
    routeName.startsWith('qa_monitor') || routePath.includes('/qa-monitor')
  );
};

const isSuperviseRoute = routeState => {
  const supervise = routeState?.query?.supervise;
  return supervise === '1' || supervise === 1 || supervise === true;
};

export default {
  markMessagesRead: async ({ commit, rootState }, data) => {
    if (
      isQaMonitorRoute(rootState?.route) ||
      isSuperviseRoute(rootState?.route)
    )
      return;

    commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id: data.id });
    emitter.emit(BUS_EVENTS.REFRESH_SIDEBAR_UNREAD_COUNTS);

    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
    } catch (error) {
      // silently fail - count was already cleared optimistically
    }
  },

  markMessagesUnread: async ({ commit, rootState }, { id }) => {
    if (isQaMonitorRoute(rootState?.route)) return;

    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
      // Notify sidebar to refresh unread counts
      emitter.emit(BUS_EVENTS.REFRESH_SIDEBAR_UNREAD_COUNTS);
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
